import axios from "axios";
import { gapi } from "./api.js";
import str from "../index.js";
const url = gapi + "student";
const studentsView = gapi + "stdView";

const students = {
  namespaced: true,
  state: {
    stdAll: [],
    stdView: [],
    level: [],
    colg: [],
    cname: [],
    cdistrict: [],
  },
  getters: {
    GET_STDALL: (state) => {
      return state.stdAll;
    },
    GET_STDVIEW: (state) => {
      return state.stdView;
    },
    getTodoById: (state) => (id) => {
      return state.stdAll.find((todo) => todo.id == id);
    },
  },
  mutations: {
    SET_STUDENTS(state, students) {
      state.stdAll = students;
    },
    STUDENTS_VIEW(state, students) {
      state.stdView = students;
    },
    ADD_STUDENTS(state, data) {
      state.stdAll.unshift(data);
    },
    ADD_STUDENTSV(state, data) {
      this.level = str.state.levels.find((todo) => todo.id == data.Level_id);
      this.colg = str.state.colleges.find((todo) => todo.id == data.Collage_id);
      this.cname = str.state.cities.find((todo) => todo.id == data.city_id);
      this.cdistrict = str.state.districts.find(
        (todo) => todo.id == data.district_id
      );
      var addview = {
        id: data.id,
        Fname: data.Fname,
        Sname: data.Sname,
        Tname: data.Tname,
        Ffname: data.Ffname,
        AmountSub: data.AmountSub,
        branch: data.branch,
        classyears: data.classyears,
        nLevel: this.level.nLevel,
        addressFather: data.addressFather,
        collageName: this.colg.collageName,
        mob: data.mob,
        mobFather: data.mobFather,
        cName: this.cname.cName,
        dName: this.cdistrict.dName,
      };
      state.stdView.unshift(addview);
    },
    UPDATE_STUDENTS(state, data) {
      const index = state.stdAll.findIndex((t) => t.id === data.id);
      const indexView = state.stdView.findIndex((t) => t.id === data.id);
      var ind = state.stdView.find((t) => t.id === data.id);

      if (index !== -1) {
        state.stdAll.splice(index, 1, data);
      }

      this.level = str.state.levels.find((todo) => todo.id == data.Level_id);
      this.colg = str.state.colleges.find((todo) => todo.id == data.Collage_id);
      this.cname = str.state.cities.find((todo) => todo.id == data.city_id);
      this.cdistrict = str.state.districts.find(
        (todo) => todo.id == data.district_id
      );
      var dts = {
        id: data.id,
        Fname: data.Fname,
        Sname: data.Sname,
        Tname: data.Tname,
        Ffname: data.Ffname,
        mob: data.mob,
        branch: data.branch,
        Type: data.Type,
        addressFather: data.addressFather,
        classyears: data.classyears,
        city_id: data.city_id,
        district_id: data.district_id,
        Level_id: data.Level_id,
        Collage_id: data.Collage_id,
        AmountSub: data.AmountSub,
        contractType_id: data.contractType_id,
        transfareType_id: data.transfareType_id,
        nLevel: this.level.nLevel,
        collageName: this.colg.collageName,
        mobFather: data.mobFather,
        cName: this.cname.cName,
        dName: this.cdistrict.dName,
      };
      if (ind !== -1) {
        state.stdView.splice(indexView, 1, dts);
      }
    },
    DELETE_STUDENTS(state, data) {
      state.stdAll = state.stdAll.filter((t) => data.id !== t.id);
      state.stdView = state.stdView.filter((t) => data.id !== t.id);
    },
  },
  actions: {
    // get all students
    async fetchStudents({ commit }) {
      await axios
        .get(url, { headers: { Authorization: str.state.token } })
        .then((res) => {
          commit("SET_STUDENTS", res.data.data);
          // console.log(res.data.data)
        })
        .catch((error) => console.log(error));
    }, // get all students view with reletion
    async StudentView({ commit }) {
      await axios
        .get(studentsView, { headers: { Authorization: str.state.token } })
        .then((res) => {
          commit("STUDENTS_VIEW", res.data.data);
          // console.log(res.data.data)
        })
        .catch((error) => console.log(error));
    },
    async loadnav({ commit }) {
      await axios
        .get(studentsView, { headers: { Authorization: str.state.token } })
        .then((res) => {
          commit("SET_ROLE_NOW", res.data.data.role, { root: true });
          // console.log(res.data.data)
        })
        .catch((error) => console.log(error));
    },
    // add student
    async addStudents({ commit }, students) {
      await axios
        .post(url, students, { headers: { Authorization: str.state.token } })
        .then((res) => {
          commit("ADD_STUDENTS", res.data.data);

          commit("ADD_STUDENTSV", res.data.data);
          // this.loadStudents()
        })
        .catch((error) => console.log(error));
    },
    // get student to edit
    async getStudent(id) {
      await axios
        .get(url + "/" + id, { headers: { Authorization: str.state.token } })
        .then((res) => {
          return res.data.data;
          // this.loadStudents()
        })
        .catch((error) => console.log(error));
    },
    // update student
    async updateStudents({ commit }, students) {
      var app = url + "/" + students.id;
      await axios
        .put(app, students, { headers: { Authorization: str.state.token } })
        .then(
          commit("UPDATE_STUDENTS", students)
          // console.log(res.data.data)
        )
        .catch((error) => console.log(error));
    },
    // delete student
    async deleteStudents({ commit }, students) {
      var app = url + "/" + students.id;
      await axios
        .delete(app, { headers: { Authorization: str.state.token } })
        .then(
          commit("DELETE_STUDENTS", students)

          // console.log(res.data.data)
        )
        .catch((error) => console.log(error));
    },
  },
};
export default students;
